(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-view-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__qvDrawerInit) return;
    window.__qvDrawerInit = true;

    var drawer, overlay, panel, mount;

    function grab() {
      drawer = document.querySelector('[data-qv-drawer]');
      if (!drawer) return false;
      overlay = drawer.querySelector('[data-qv-overlay]');
      panel = drawer.querySelector('.qv-drawer__panel');
      mount = drawer.querySelector('[data-qv-mount]');
      return true;
    }

    function openDrawer() {
      drawer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () {
        drawer.hidden = true;
        mount.innerHTML = '<div class="qv-drawer__loading"><span class="qv-spin"></span></div>';
      }, 320);
    }

    function load(url) {
      if (!grab()) return;
      mount.innerHTML = '<div class="qv-drawer__loading"><span class="qv-spin"></span></div>';
      openDrawer();
      var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-view';
      fetch(u, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('[data-qv]');
          mount.innerHTML = '';
          if (content) { mount.appendChild(content); initContent(mount); }
          else { mount.innerHTML = '<div class="qv-drawer__loading">Yüklenemedi</div>'; }
        })
        .catch(function () { mount.innerHTML = '<div class="qv-drawer__loading">Yüklenemedi</div>'; });
    }

    function initContent(scope) {
      var root = scope.querySelector('[data-qv]');
      if (!root) return;
      var data = { variants: [] };
      var dataEl = root.querySelector('[data-qv-data]');
      if (dataEl) { try { data = JSON.parse(dataEl.textContent); } catch (e) {} }

      var idInput = root.querySelector('[data-qv-id]');
      var priceEl = root.querySelector('[data-qv-price]');
      var addBtn = root.querySelector('[data-qv-add]');
      var buyBtn = root.querySelector('[data-qv-buynow]');
      var stockEl = root.querySelector('[data-qv-stock]');
      var selected = {};

      /* ---- Galeri slider ---- */
      var slider = root.querySelector('[data-qv-slider]');
      var slides = slider ? Array.prototype.slice.call(slider.querySelectorAll('[data-qv-slide]')) : [];
      var curEl = root.querySelector('[data-qv-current]');
      var barEl = root.querySelector('[data-qv-bar]');
      var cur = 0;

      function setNav() {
        if (curEl) curEl.textContent = cur + 1;
        if (barEl) barEl.style.width = ((cur + 1) / slides.length * 100) + '%';
      }
      function goTo(i) {
        if (!slider || !slides.length) return;
        i = Math.max(0, Math.min(slides.length - 1, i));
        slider.scrollTo({ left: slides[i].offsetLeft - slider.offsetLeft, behavior: 'smooth' });
      }
      if (slider && slides.length > 1) {
        var scrollRaf = null;
        slider.addEventListener('scroll', function () {
          if (scrollRaf) return;
          scrollRaf = requestAnimationFrame(function () {
            scrollRaf = null;
            var x = slider.scrollLeft, best = 0, bd = Infinity;
            slides.forEach(function (s, i) {
              var d = Math.abs((s.offsetLeft - slider.offsetLeft) - x);
              if (d < bd) { bd = d; best = i; }
            });
            if (best !== cur) { cur = best; setNav(); }
          });
        }, { passive: true });
        var prev = root.querySelector('[data-qv-prev]');
        var next = root.querySelector('[data-qv-next]');
        if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
        if (next) next.addEventListener('click', function () { goTo(cur + 1); });

        /* ---- Fareyle sürükle-bırak kaydırma (masaüstü); dokunmatikte native ---- */
        slider.classList.add('is-draggable');
        var dragging = false, dragStartX = 0, dragStartLeft = 0, dragMoved = false;
        slider.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'touch') return; // dokunmatikte tarayıcının kendi kaydırması
          dragging = true; dragMoved = false;
          dragStartX = e.clientX;
          dragStartLeft = slider.scrollLeft;
          slider.classList.add('is-dragging');
          try { slider.setPointerCapture(e.pointerId); } catch (err) {}
        });
        slider.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          var dx = e.clientX - dragStartX;
          if (Math.abs(dx) > 4) dragMoved = true;
          slider.scrollLeft = dragStartLeft - dx;
        });
        function endDrag(e) {
          if (!dragging) return;
          dragging = false;
          slider.classList.remove('is-dragging');
          try { slider.releasePointerCapture(e.pointerId); } catch (err) {}
          if (dragMoved) goTo(cur); // en yakın slayta hizala
        }
        slider.addEventListener('pointerup', endDrag);
        slider.addEventListener('pointercancel', endDrag);
        slider.addEventListener('pointerleave', endDrag);
        /* Sürükledikten sonra oluşan istem dışı tıklamayı yut */
        slider.addEventListener('click', function (e) {
          if (dragMoved) { e.preventDefault(); e.stopPropagation(); dragMoved = false; }
        }, true);

        setNav();
      }

      root.querySelectorAll('[data-qv-option]').forEach(function (opt) {
        var pos = opt.getAttribute('data-qv-option');
        var active = opt.querySelector('.qv__value.is-active') || opt.querySelector('.qv__value');
        if (active) { selected[pos] = active.getAttribute('data-qv-val'); active.classList.add('is-active'); }
      });

      function match() {
        return data.variants.filter(function (v) {
          for (var i = 0; i < v.options.length; i++) {
            if (String(selected[i + 1]) !== String(v.options[i])) return false;
          }
          return true;
        })[0];
      }

      function update() {
        var v = match();
        root.querySelectorAll('[data-qv-optval]').forEach(function (lbl) {
          lbl.textContent = selected[lbl.getAttribute('data-qv-optval')] || '';
        });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) {
          /* Yüzde sunucuda hesaplandı (zey-pct) ve v.pct olarak geldi */
          var qvPriceHtml = '<span>' + v.price_html + '</span>';
          if (v.compare_html) {
            qvPriceHtml = '<span class="price--sale">' + v.price_html + '</span> <s>' + v.compare_html + '</s>';
            if (v.pct) qvPriceHtml += ' <span class="price__pct">%' + v.pct + '</span>';
          }
          priceEl.innerHTML = qvPriceHtml;
        }
        if (v.mid) {
          var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(v.mid); });
          if (idx > -1) goTo(idx);
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? 'Sepete Ekle' : 'Tükendi';
        }
        if (buyBtn) buyBtn.disabled = !v.available;
        if (stockEl) stockEl.style.display = v.available ? '' : 'none';
      }

      /* Beden stok durumu — kural PDP ile BİREBİR aynı (sections/product.liquid).
         Yalnız beden grupları; renkler hep tıklanabilir kalır.
         DİKKAT: bu dosyada seçili değerler `selected` nesnesinde 1-tabanlı
         opsiyon pozisyonu anahtarıyla tutulur, PDP'deki gibi dizi değil. */
      function qvRefreshAvailability() {
        root.querySelectorAll('[data-qv-option][data-qv-size]').forEach(function (group) {
          var gi = parseInt(group.getAttribute('data-qv-option'), 10) - 1;
          group.querySelectorAll('.qv__value').forEach(function (btn) {
            var val = btn.getAttribute('data-qv-val');
            var ok = data.variants.some(function (v) {
              if (v.options[gi] !== val) return false;
              for (var i = 0; i < v.options.length; i++) {
                if (i === gi) continue;
                var sel = selected[String(i + 1)];
                if (sel && v.options[i] !== sel) return false;
              }
              return v.available;
            });
            btn.classList.toggle('is-unavailable', !ok);
            btn.disabled = !ok;
            if (ok) {
              btn.removeAttribute('aria-disabled');
              btn.removeAttribute('title');
            } else {
              btn.setAttribute('aria-disabled', 'true');
              btn.setAttribute('title', 'Tükendi');
            }
          });
        });
      }

      root.querySelectorAll('.qv__value').forEach(function (b) {
        b.addEventListener('click', function () {
          var pos = b.getAttribute('data-qv-opt');
          selected[pos] = b.getAttribute('data-qv-val');
          root.querySelectorAll('.qv__value[data-qv-opt="' + pos + '"]').forEach(function (x) {
            x.classList.toggle('is-active', x === b);
          });
          qvRefreshAvailability();
          update();
        });
      });

      var qty = root.querySelector('[data-qv-qty-input]');
      root.querySelectorAll('[data-qv-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var d = parseInt(b.getAttribute('data-qv-qty'), 10);
          var n = Math.max(1, (parseInt(qty.value, 10) || 1) + d);
          qty.value = n;
        });
      });

      /* ---- Hemen Al ---- */
      if (buyBtn) {
        buyBtn.addEventListener('click', function () {
          if (buyBtn.disabled || !idInput) return;
          buyBtn.classList.add('is-busy');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(idInput.value, 10), quantity: parseInt(qty && qty.value, 10) || 1 })
          })
            .then(function (r) {
              if (!r.ok) throw new Error('add failed');
              // İl/ilçe seçimi varsa ödemeye aktarılır, yoksa sepette seçtirilir (assets/teslimat-secim.js).
              if (window.ZeyTeslimat) window.ZeyTeslimat.odemeyeGit(); else window.location.href = '/checkout';
            })
            .catch(function () {
              buyBtn.classList.remove('is-busy');
              var form = root.querySelector('form');
              if (form) form.submit();
            });
        });
      }

      update();
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quick-view-url]');
      if (trigger) { e.preventDefault(); load(trigger.getAttribute('data-quick-view-url')); return; }
      if (e.target.closest('[data-qv-close]') || e.target.closest('[data-qv-overlay]')) { closeDrawer(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
